import { render, staticRenderFns } from "./ViewInfoArticle.vue?vue&type=template&id=1e20e8f5&scoped=true"
import script from "./ViewInfoArticle.vue?vue&type=script&lang=js"
export * from "./ViewInfoArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e20e8f5",
  null
  
)

export default component.exports